import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-adduserrole',
  templateUrl: './adduserrole.component.html',
  styleUrls: ['./adduserrole.component.css']
})
export class AdduserroleComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  userroleColl: any = [];
  userroleid: number = 0
  urolerightsColl: any = [];
  moduleBO: any = {};
  moduleColl: any = [];
  settingsColl: any = [];

  rolereadonly: boolean = false;
  editformtype: string = "";


  userroleform = new FormGroup({
    userroleid: new FormControl(0),
    //productgroup:new FormControl('',Validators.required),            
    userrolename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Userrole";


  constructor(private appService: DhukanDataService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.userroleid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.userroleform.reset();
      this.fnInitializeUserrole();

      if (this.userroleid > 0) {
        this.fngetUserrole();
      }
      this.fngetUserRoleRights();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.userroleid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeUserrole() {
    this.userroleform.setValue({

      userroleid: 0,
      userrolename: '',
      inactive: false,
    })
  }
  fnSetTable() {
    
  }
  fngetSettingsValue(){
    this.settingsColl=[];
    this.settingsColl.push({value:1,displayname:'True'})
    this.settingsColl.push({value:0,displayname:'False'})
  }
  fngetUserRoleRights() {

    var data = {
      'userroleid': this.userroleid,
      'organizationid': this.loginService.fnGetOrganizationId(),
      'modifiedby':this.loginService.fnGetModUserId()
    }
    this.appService.getUserRoleRights(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
          //console.log(result)


          this.urolerightsColl = result[0];
        

          this.moduleColl = result[1];
         // //console.log(this.urolerightsColl)

          this.fnSetTable();

          if (this.moduleColl.length > 0) {

            this.fnTabClickModule(this.moduleColl[0])
          }


          for (let abo of this.urolerightsColl) {
            abo.uappall = false;

            if (abo.salessettingsid > 0) {
              if (abo.settingsvalue === "1") {
                abo.ischecksales = true;
              }
              else {
                abo.ischecksales = false;
              }
            }
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Get 
  fngetUserrole() {
    var data = {
      'userroleid': this.userroleid,
      'modifiedby': this.loginService.fnGetModUserId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUserrole(data)
      .subscribe(
        (res) => {
          this.userroleColl = res.json().result;
          var editdata = this.userroleColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.userroleform.valid) {
        this.saveloading=true;

        for(let abo of this.urolerightsColl){
          if (abo.salessettingsid > 0) {
            if (abo.ischecksales === true) {
              abo.settingsvalue = "1"
            }
            else {
              abo.settingsvalue = "0"
            }
          }
        }

        
        //Check
        var data = {
          'userroleid': this.userroleid,
          'userrolename': this.userroleform.get('userrolename').value,
          'inactive': this.userroleform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'urolerightsColl': this.urolerightsColl,
        }

       
        this.appService.fnCheckUserrole(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.userroleform.get('userroleid').value > 0) {
                //Update Department
                this.fnSetUserrole(data);
              }
              else {
                //Insert Department
                this.fnInsertUserrole(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false;

                this.userroleform.controls['userrolename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertUserrole(data) {

    this.appService.fnInsertUserrole(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The New userrole has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.userrolename);

          this.fnCloseUserrole();
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetUserrole(data) {

    this.appService.fnSetUserrole(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The userrole has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.userroleid, data.userrolename);

          this.fnCloseUserrole();
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseUserrole() {
    try {
      this.router.navigate(['/Userrole']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnTabClickModule(item) {

    this.editformtype = item.modulename;
    

    for (let abo of this.moduleColl) {

      if (abo.modulename === item.modulename) {

        abo.activeCls = "activetab"


        this.moduleBO = abo

      }
      else {
        abo.activeCls = ""
      }
    }



  }

  fnSaveAsBtnClick() {
    try {
      this.userroleid = 0;
      this.fnInitializeUserrole();
      this.router.navigate([]);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckAllRights(event, deptBO) {


    if (event) {
      if (deptBO.ucreate) {
        deptBO.uappcreate = true;
      }
      if (deptBO.ualter) {
        deptBO.uappalter = true;
      }
      if (deptBO.udelete) {
        deptBO.uappdelete = true;
      }
      if (deptBO.uview) {
        deptBO.uappview = true;
      }
      if (deptBO.uprint) {
        deptBO.uappprint = true;
      }
      if (deptBO.uexport) {
        deptBO.uappexport = true;
      }
      if (deptBO.upayment) {
        deptBO.uapppayment = true;
      }
      if (deptBO.uapproval) {
        deptBO.uappapproval = true;
      }
      if (deptBO.ureject) {
        deptBO.uappreject = true;
      }


    }
    else {


      deptBO.uappcreate = false;
      deptBO.uappalter = false;
      deptBO.uappdelete = false;
      deptBO.uappview = false;
      deptBO.uappprint = false;
      deptBO.uappexport = false;
      deptBO.uapppayment = false;
      deptBO.uappapproval = false;
      deptBO.uappreject = false;
    }



  }

  private fnEditMode(deptBO) {

    this.userroleform.setValue({

      userroleid: deptBO.userroleid,
      userrolename: deptBO.userrolename,
      inactive: deptBO.inactive,
    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (deptBO.isfixedrole === 1) {
      this.rolereadonly = true;
}
  
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
